import { useQuery } from '@tanstack/react-query';

import { faqApi, faqKeys } from '../faq.api';

/**
 * Catálogo de preguntas frecuentes.
 *
 * Cambia sólo cuando un administrador edita el FAQ, así que se cachea 10
 * minutos para que navegar entre vistas no vuelva a pedirlo.
 */
export function useFaq() {
  return useQuery({
    queryKey: faqKeys.all,
    queryFn: ({ signal }) => faqApi.get(signal),
    staleTime: 10 * 60_000,
  });
}
